import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import { loadingStyles } from './loadingStyles';

var Loading = function Loading(_ref) {
  var loading = _ref.loading;
  var classes = loadingStyles();

  if (!loading) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: classes.loadingPanel
  }, /*#__PURE__*/React.createElement(CircularProgress, {
    className: classes.progress
  }));
};

Loading.propTypes = {
  loading: PropTypes.bool.isRequired
};
export { Loading };
export default Loading;